import { all, takeLatest } from 'redux-saga/effects';
import {
  PASSWORD_RESET_REQUEST_REQUEST,
  PASSWORD_RESET_REQUEST,
} from './constants';
import {
  passwordResetRequestFailure,
  passwordResetRequestSuccess,
  passwordResetFailure,
  passwordResetSuccess,
} from './actions';
import { apiSaga } from 'sagas';
import { postPasswordReset, patchPasswordReset } from 'utils/api';

export function* passwordResetRequestFlow({ payload }) {
  yield* apiSaga(
    postPasswordReset,
    [{ email: payload.email }],
    passwordResetRequestSuccess,
    passwordResetRequestFailure
  );
}

export function* passwordResetFlow({ payload }) {
  const args = [{
    password: payload.password,
    password_confirmation: payload.password_confirmation,
    reset_password_token: payload.reset_password_token,
  }];

  yield* apiSaga(patchPasswordReset, args, passwordResetSuccess, passwordResetFailure);
}

export default function* watchSignIn() {
  yield all([
    takeLatest(PASSWORD_RESET_REQUEST_REQUEST, passwordResetRequestFlow),
    takeLatest(PASSWORD_RESET_REQUEST, passwordResetFlow),
  ]);
}



// WEBPACK FOOTER //
// ./src/containers/ForgotPasswordPage/sagas.js